import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  country_name: "",
  company_duns: "",
  vendor_question_checkbox: {
    value: [],
    label: "",
  },
  company_name: { value: "", label: "" },
  company_id: "",
  activity_sector: { value: "", label: "" },
  company_phone_number_prefix: {
    value: "",
    label: "",
  },
  legal_form: { value: "", label: "" },
  siren: { value: "", label: "" },
  siret: { value: "", label: "" },
  eu_vat_tax: { value: "", label: "" },
  local_tax_no: { value: "", label: "" },
  street: { value: "", label: "" },
  city: { value: "", label: "" },
  zip_code: { value: "", label: "" },
  country: { value: "", label: "" },
  states: { value: "", label: "" },
  company_type: { value: "", label: "" },
  chamber_of_commerce_number: {
    value: "",
    label: "Chamber of Commerce Number",
  },
  delivery: {
    same_as_address: {
      value: null,
      label: "",
    },
    street: {
      value: "",
      label: "",
    },
    city: {
      value: "",
      label: "",
    },
    zip_code: {
      value: "",
      label: "",
    },
    country: {
      value: "",
      label: "",
    },
    address_confirm: {
      value: false,
      label: "",
    },
  },
  postal: {
    same_as_address: {
      value: null,
      label: "",
    },
    street: {
      value: "",
      label: "",
    },
    city: {
      value: "",
      label: "",
    },
    zip_code: {
      value: "",
      label: "",
    },
    country: {
      value: "",
      label: "",
    },
  },
  company_phone_number: { value: "", label: "" },
  company_site_or_portal: { value: "", label: "" },
  salutation: { value: "", label: "" },
  first_name: { value: "", label: "" },
  middle_name: { value: "", label: "" },
  last_name: { value: "", label: "" },
  phone_number_select: { value: "", label: "" },
  phone_number: { value: "", label: "" },
  email: { value: "", label: "" },

  country_interests_checkbox: {
    value: [],
    label: "",
  },
  informed_by_email_checkbox: {
    value: null,
    label: "",
  },
  informed_by_other_ways_checkbox: {
    value: [],
    label: "",
  },
  specific_checkbox: {
    value: "",
    label: "",
  },
  uploaded_documents: {
    value: [],
    label: "",
  },
  accept_conditions: {
    value: false,
    label: "",
  },
  electronic_signature: {
    file: "",
    fileName: "signature.png",
  },

  found_interest: {
    value: null,
    label: "",
  },
};

export const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setCountryName: (state, action) => {
      if (state.country_name === "") {
        state.country_name = action.payload;
      }
    },

    changeDuns: (state, action) => {
      state.company_duns = action.payload;
    },

    changeCountryName: (state, action) => {
      state.country_name = action.payload;
    },

    setCompanyInformation: (state, action) => {
      if (state.vendor_question_checkbox.value.length !== 0) {
        state.vendor_question_checkbox.value =
          action.payload.vendor_question_checkbox.options.map(
            (option, index) => ({
              ...option,
              checked: state.vendor_question_checkbox.value[index].checked,
            })
          );
      } else {
        state.vendor_question_checkbox.value =
          action.payload.vendor_question_checkbox.options;
        state.vendor_question_checkbox.label =
          action.payload.vendor_question_checkbox.label;
      }

      state.company_name.label = action.payload.company_name.label;
      state.activity_sector.label = action.payload.activity_sector.label;
      state.company_type.label = action?.payload?.company_type?.label || "";
      state.legal_form.label = action.payload.legal_form.label;
      state.siren.label = action.payload.siren?.label || "";
      state.siret.label = action.payload.siret?.label || "";
    },

    changeVendorQuestionCheckbox: (state, action) => {
      state.vendor_question_checkbox.value.forEach((vendorQuestion) => {
        if (vendorQuestion.value === action.payload) {
          vendorQuestion.checked = !vendorQuestion.checked;
        }
      });
    },

    changeCompanyName: (state, action) => {
      state.company_name.value = action.payload;
    },

    changeCompanyId: (state, action) => {
      state.company_id = action.payload;
    },

    changeActivitySector: (state, action) => {
      state.activity_sector.value = action.payload;
    },

    changeCompanyPhoneNumberPrefix: (state, action) => {
      state.company_phone_number_prefix.value = action.payload;
    },

    changeLegalForm: (state, action) => {
      state.legal_form.value = action.payload;
    },

    changeSiren: (state, action) => {
      state.siren.value = action.payload;
    },

    changeSiret: (state, action) => {
      state.siret.value = action.payload;
    },

    setCompanyDetails: (state, action) => {
      state.eu_vat_tax.label = action.payload.eu_vat_tax?.label || "";
      state.local_tax_no.label = action.payload.local_tax_no?.label || "";
      state.street.label = action.payload.street_name_and_number.label;
      state.city.label = action.payload.city.label;
      state.zip_code.label = action.payload.zip_code.label;
      state.country.label = action.payload.country.label;
      state.states.label = action?.payload?.states?.label || "";
      state.delivery.same_as_address.label =
        action.payload.delivery_address.label;
      state.delivery.street.label = `Delivery ${action.payload.street_name_and_number.label}`;
      state.delivery.city.label = `Delivery ${action.payload.city.label}`;
      state.delivery.zip_code.label = `Delivery ${action.payload.zip_code.label}`;
      state.delivery.country.label = `Delivery ${action.payload.country.label}`;
      state.delivery.address_confirm.label = `${action.payload.confirmation.label} ${action.payload.confirmation.external_link.label}`;
      state.postal.same_as_address.label = action.payload.postal_address.label;
      state.postal.street.label = `Postal ${action.payload.street_name_and_number.label}`;
      state.postal.city.label = `Postal ${action.payload.city.label}`;
      state.postal.zip_code.label = `Postal ${action.payload.zip_code.label}`;
      state.postal.country.label = `Postal ${action.payload.country.label}`;
      state.company_phone_number.label =
        action.payload.company_phone_number.label;
      state.company_site_or_portal.label =
        action.payload.company_site_or_portal.label;

      state.company_phone_number_prefix.label = "prefixes";
      if (!state.company_phone_number_prefix.value) {
        state.company_phone_number_prefix.value =
          action.payload.company_phone_number?.prefixes?.find(
            (item) => item.country_code === state.country_name
          )?.country_prefix_phone_code;
      }
    },

    changeEuVatTax: (state, action) => {
      state.eu_vat_tax.value = action.payload;
    },

    changeLocalTaxNo: (state, action) => {
      state.local_tax_no.value = action.payload;
    },

    changeStreetNameAndNumber: (state, action) => {
      state.street.value = action.payload;
    },

    changeCity: (state, action) => {
      state.city.value = action.payload;
    },

    changeZipCode: (state, action) => {
      state.zip_code.value = action.payload;
    },

    setCountry: (state, action) => {
      if (state.country.value === "") {
        state.country.value = action.payload;
      }
    },

    changeCountry: (state, action) => {
      state.country.value = action.payload;
    },

    setStates: (state, action) => {
      if (state.states.value === "") {
        state.states.value = action.payload;
      }
    },

    changeStates: (state, action) => {
      state.states.value = action.payload;
    },

    setCompanyType: (state, action) => {
      if (state.company_type.value === "") {
        state.company_type.value = action.payload;
      }
    },

    changeCompanyType: (state, action) => {
      state.company_type.value = action.payload;
    },

    changeDeliverySameAsAddress: (state, action) => {
      state.delivery.same_as_address.value = action.payload;
      state.delivery.address_confirm.value = false;
    },

    changeDeliveryStreetNameAndNumber: (state, action) => {
      state.delivery.street.value = action.payload;
    },

    changeDeliveryCity: (state, action) => {
      state.delivery.city.value = action.payload;
    },

    changeDeliveryZipCode: (state, action) => {
      state.delivery.zip_code.value = action.payload;
    },

    changeDeliveryCountry: (state, action) => {
      state.delivery.country.value = action.payload;
    },

    changeDeliveryAddressConfirm: (state, action) => {
      state.delivery.address_confirm.value = action.payload;
    },

    changePostalSameAsAddress: (state, action) => {
      state.postal.same_as_address.value = action.payload;
    },

    changePostalStreetNameAndNumber: (state, action) => {
      state.postal.street.value = action.payload;
    },

    changePostalCity: (state, action) => {
      state.postal.city.value = action.payload;
    },

    changePostalZipCode: (state, action) => {
      state.postal.zip_code.value = action.payload;
    },

    changePostalCountry: (state, action) => {
      state.postal.country.value = action.payload;
    },

    changeCompanyPhoneNumber: (state, action) => {
      state.company_phone_number.value = action.payload;
    },

    changeCompanySiteOrPortal: (state, action) => {
      state.company_site_or_portal.value = action.payload;
    },

    setContactInformation: (state, action) => {
      state.salutation.label = action.payload.salutation.label;

      if (state.salutation.value === "") {
        state.salutation.value = action.payload.salutation.options[0].value;
      }

      state.first_name.label = action.payload.first_name.label;
      state.middle_name.label = action.payload.middle_name.label;
      state.last_name.label = action.payload.last_name.label;
      state.phone_number_select.label =
        action.payload.phone_number_select.label;

      if (state.phone_number_select.value === "") {
        state.phone_number_select.value =
          action.payload.phone_number_select.options[0].value;
      }

      state.phone_number.label = action.payload.phone_number.label;
      state.email.label = action.payload.email.label;
    },

    changeSalutation: (state, action) => {
      state.salutation.value = action.payload;
    },

    changeFirstName: (state, action) => {
      state.first_name.value = action.payload;
    },

    changeMiddleName: (state, action) => {
      state.middle_name.value = action.payload;
    },

    changeLastName: (state, action) => {
      state.last_name.value = action.payload;
    },

    changePhoneNumberSelect: (state, action) => {
      state.phone_number_select.value = action.payload;
    },

    changePhoneNumber: (state, action) => {
      state.phone_number.value = action.payload;
    },

    changeEmail: (state, action) => {
      state.email.value = action.payload;
    },

    changeChamberOfCommerceNumber: (state, action) => {
      state.chamber_of_commerce_number.value = action.payload;
    },

    setFinalDetails: (state, action) => {
      state.country_interests_checkbox.label =
        action?.payload?.country_interests_checkbox?.label;

      if (state?.country_interests_checkbox?.value < 1) {
        state.country_interests_checkbox.value =
          action?.payload?.country_interests_checkbox?.options;
      }

      state.informed_by_email_checkbox.label =
        action?.payload?.informed_by_email_checkbox?.label;
      state.informed_by_other_ways_checkbox.label =
        action?.payload?.informed_by_other_ways_checkbox?.label;

      if (state?.informed_by_other_ways_checkbox?.value?.length < 1) {
        state.informed_by_other_ways_checkbox.value =
          action?.payload?.informed_by_other_ways_checkbox?.options;
      }

      state.specific_checkbox.label =
        action?.payload?.specific_for_country?.text;
      state.uploaded_documents.label = action?.payload?.upload_documents_label;
      state.accept_conditions.label = action?.payload?.tc_and_privacy?.label;
    },

    changeCountryInterestsCheckbox: (state, action) => {
      state.country_interests_checkbox.value.forEach((countryInterest) => {
        if (countryInterest.value === action.payload) {
          countryInterest.checked = !countryInterest.checked;
        }
      });
    },

    changeInformedByEmailCheckbox: (state, action) => {
      state.informed_by_email_checkbox.value = action.payload;
    },

    changeInformedByOtherWaysCheckbox: (state, action) => {
      state.informed_by_other_ways_checkbox.value.forEach((checkbox) => {
        if (checkbox.value === action.payload) {
          checkbox.checked = !checkbox.checked;
        }
      });
    },

    changeSpecificCheckbox: (state, action) => {
      state.specific_checkbox.value = action.payload;
    },

    changeUploadDocuments: (state, action) => {
      const documents = [...state.uploaded_documents.value];

      documents[action.payload.index] = action.payload.data;

      state.uploaded_documents.value = documents;
    },

    changeTcAndPrivacy: (state, action) => {
      state.accept_conditions.value = action.payload;
    },

    changeElectronicSignature: (state, action) => {
      state.electronic_signature.file = action.payload;
    },

    setSocialSelectModal: (state, action) => {
      state.found_interest.label =
        action?.payload?.where_did_you_hear_about_bca_label;

      if (state?.found_interest?.value === null) {
        state.found_interest.value =
          action?.payload?.select_options.options[0]?.value;
      }
    },

    changeFoundInterest: (state, action) => {
      state.found_interest.value = action.payload;
    },

    setAddContactPerson: (state, action) => {
      state.company_name.label = action.payload.company_name_form.label;
      state.street.label = action.payload.street_name_and_number_form.label;
      state.city.label = action.payload.city_form.label;
      state.zip_code.label = action.payload.zip_code_form.label;
      state.salutation.label = action.payload.salutation.label;
      state.states.label = action.payload?.states?.label || "";
      if (state.salutation.value === "") {
        state.salutation.value = action.payload.salutation.options[0].value;
      }
      state.first_name.label = action.payload.first_name.label;
      state.middle_name.label = action.payload.middle_name.label;
      state.last_name.label = action.payload.last_name.label;
      state.phone_number.label = action.payload.phone_number.label;
      state.email.label = action.payload.email.label;
      state.country_interests_checkbox.label =
        action.payload.country_interests_checkbox.label;
      if (state.country_interests_checkbox.value < 1) {
        state.country_interests_checkbox.value =
          action.payload.country_interests_checkbox.options;
      }
      state.informed_by_email_checkbox.label =
        action.payload.informed_by_email_checkbox.label;
      state.informed_by_other_ways_checkbox.label =
        action.payload.informed_by_other_ways_checkbox.label;
      if (state.informed_by_other_ways_checkbox.value.length < 1) {
        state.informed_by_other_ways_checkbox.value =
          action.payload.informed_by_other_ways_checkbox.options;
      }
      state.uploaded_documents.label = action.payload.upload_documents_label;
      state.accept_conditions.label = action.payload.tc_and_privacy.label;
    },
    resetForm: () => initialState,
    resetCompanyInformation: (state) => {
      state.company_id = initialState.company_id;
      state.company_name = initialState.company_name;
      state.street = initialState.street;
      state.city = initialState.city;
      state.zip_code = initialState.zip_code;
      state.activity_sector = initialState.activity_sector;
      state.legal_form = initialState.legal_form;
      state.company_duns = initialState.company_duns;
    },
    resetData: (state, action) => ({
      initialState,
      country_name: action.payload,
    }),
  },
});

export const {
  setCountryName,
  changeCountryName,
  setCompanyInformation,
  changeVendorQuestionCheckbox,
  changeCompanyName,
  changeDuns,
  changeCompanyId,
  changeActivitySector,
  changeCompanyPhoneNumberPrefix,
  changeLegalForm,
  changeSiren,
  changeSiret,
  setCompanyDetails,
  changeEuVatTax,
  changeLocalTaxNo,
  changeStreetNameAndNumber,
  changeCity,
  changeZipCode,
  setCountry,
  changeCountry,
  setStates,
  changeStates,
  setCompanyType,
  changeCompanyType,
  changeDeliverySameAsAddress,
  changeDeliveryStreetNameAndNumber,
  changeDeliveryCity,
  changeDeliveryZipCode,
  changeDeliveryCountry,
  changeDeliveryAddressConfirm,
  changePostalSameAsAddress,
  changePostalStreetNameAndNumber,
  changePostalCity,
  changePostalZipCode,
  changePostalCountry,
  changeCompanyPhoneNumber,
  changeCompanySiteOrPortal,
  setContactInformation,
  changeSalutation,
  changeFirstName,
  changeMiddleName,
  changeLastName,
  changePhoneNumberSelect,
  changePhoneNumber,
  changeEmail,
  setFinalDetails,
  changeCountryInterestsCheckbox,
  changeChamberOfCommerceNumber,
  changeInformedByEmailCheckbox,
  changeInformedByOtherWaysCheckbox,
  changeSpecificCheckbox,
  changeUploadDocuments,
  changeTcAndPrivacy,
  changeElectronicSignature,
  setSocialSelectModal,
  changeFoundInterest,
  setAddContactPerson,
  resetForm,
  resetCompanyInformation,
  resetData,
} = formSlice.actions;

export default formSlice.reducer;
